'use client'

import { QueryKeys } from '@/lib/utils'
import {
  getActiveChannelDoc,
  getActiveChannelQuery,
} from '@/lib/vendure/queries/get-active-channel'
import { useQuery } from '@tanstack/react-query'
import { ResultOf } from 'gql.tada'
import { PropsWithChildren, createContext, useContext } from 'react'

type GlobalContext = {
  activeChannel: ResultOf<typeof getActiveChannelDoc> | undefined
}

export const GlobalContext = createContext<GlobalContext | undefined>(undefined)

type GlobalContextProviderProps = {}

export function GlobalContextProvider({ children }: PropsWithChildren<GlobalContextProviderProps>) {
  const activeChannel = useQuery({
    queryKey: QueryKeys.activeChannel,
    queryFn: async () => {
      const res = await fetch('/api/channel')
      return (await res.json()) as ResultOf<typeof getActiveChannelQuery>
    },
  })

  return (
    <GlobalContext.Provider value={{ activeChannel: activeChannel.data }}>
      {children}
    </GlobalContext.Provider>
  )
}

export const useGlobalContext = () => {
  const context = useContext(GlobalContext)
  if (!context) {
    throw new Error('useGlobalContext must be used within a GlobalContextProvider')
  }
  return context
}
